import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import {
  TripMatch, TripRequest,
} from '@marageti/z4-sdk/lib/travel';
import { Traveler, TravelerProfile } from '@marageti/z4-sdk/lib/people';
import DetailsView from './details-view';
import { getShowRequestReview } from '../../../utils/helpers';
import { useAuthStore } from '../../../store';

const DetailsContainer = () => {
  const apiClient = useApiClient();
  const { tripMatchId } = useParams();
  const [reviewJustSent, setReviewJustSent] = useState(false);
  const { loggedInTeamMember } = useAuthStore();
  const {
    data: tripMatchData,
    isLoading: isLoadingTripMatch,
  } = useFetch<TripMatch>(
    apiClient.tripMatchesClient.getTripMatch,
    [tripMatchId],
    true,
  );
  const tripRequestFetchResult = useFetch<TripRequest>(
    apiClient.tripRequestsClient.getTripRequest,
    [tripMatchData?.tripRequestId ? tripMatchData?.tripRequestId : ''],
    !!tripMatchData?.tripRequestId,
  );
  const travelerId = tripRequestFetchResult.data?.travelers[0].id;
  const travelerProfile = useFetch<TravelerProfile>(apiClient.peopleClient.getTravelerProfile, [travelerId], !!travelerId);
  const { data: primaryTraveler } = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);
  const showRequestReview = getShowRequestReview(tripMatchData) && !reviewJustSent;
  const loading = (!tripMatchData || !tripRequestFetchResult.data) || (tripRequestFetchResult.isLoading || isLoadingTripMatch);
  const travelers = primaryTraveler && tripMatchData?.travelers && tripMatchData.travelers.length > 0
    ? [primaryTraveler, ...tripMatchData.travelers.slice(1)]
    : tripMatchData?.travelers;

  const onReviewSent = () => {
    setReviewJustSent(true);
  };

  return (
    <DetailsView
      loading={loading}
      travelerId={travelerId}
      tripMatch={tripMatchData}
      tripRequest={tripRequestFetchResult.data}
      travelers={travelers}
      showRequestReview={showRequestReview}
      onNotesEdit={tripRequestFetchResult.mutate}
      onTravelerEdit={travelerProfile.mutate}
      onReviewSent={onReviewSent}
      loggedInTeamMember={loggedInTeamMember}
    />
  );
};

export default DetailsContainer;
